import createStore from './store/configureStore';

export const store = createStore();

export default store;